import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { directCreateService } from "../functions/document/directCreateService";
import { openCasualPerson } from "../functions/document/openCasualPerson";
import { insertNewPerson } from "../functions/insertNewPerson";
import { emptys } from "../../../data/main";

export const serviceModal = ({
  t,
  user,
  usersList,
  staffList,
  modalData,
  items,
  dispatch,
  openWindow,
  setDocValues,
  setDocModal,
  setWindowValues,
  packArrangeDoc,
  writeDataParams,
  windowValues,
  setMsg,
  setMsg2,
  setModalData,
  setModalData2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  const packFuncs = {
    t,
    user,
    usersList,
    staffList,
    items,
    dispatch,
    setDocValues,
    setDocModal,
    setWindowValues,
    packArrangeDoc,
    writeDataParams,
    windowValues: windowValues.service,
    setMsg,
    setMsg2,
    setModalData,
    setModalData2,
    closeMsg,
    logoutAction,
  };

  const validateData = () => {
    if (
      windowValues.service.CLI?.length > 0 &&
      windowValues.service.INT?.length > 0
    ) {
      return true;
    } else {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        label:
          t("p.youNeedFillField") +
          (!windowValues.service.INT ? t("c.INT") : t("c.CLI")),
      });
      return false;
    }
  };

  return {
    title: t("p.newSEV"),
    mainColor: modalData.mainColor,
    blocked: true,
    inputListStyle: { height: 300 },
    inputs:
      "inputs" in modalData &&
      modalData.inputs.map((e: stdObject) => {
        const { code, name, label, searchType, type, options } = e;
        return {
          code,
          label,
          value:
            code === "FEC2"
              ? windowValues.service?.[code]
              : (windowValues.service?.[name] ?? t("p.search")),
          type,
          options,
          quickData:
            code === "FEC2"
              ? false
              : {
                  search: true,
                  type: searchType,
                  new: () =>
                    insertNewPerson(code, {
                      t,
                      mainColor: colors.service,
                      openWindow,
                    }),
                  casual: () => {
                    openCasualPerson({
                      t,
                      level: 2,
                      type: code,
                      docData: { data: {}, type },
                      windowValues,
                      setMsg,
                      setMsg2,
                      setWindowValues,
                    });
                  },
                  clean: () => {
                    let tempValues = windowValues;
                    delete tempValues.service[code];
                    delete tempValues.service[name];
                    if (code === "CLI") {
                      delete tempValues.service.customer;
                    }
                    setWindowValues({ ...tempValues });
                  },
                },
          innerStyle: {
            width: 250,
            backgroundColor:
              windowValues.service?.[code]?.length > 0
                ? colors.lightGreen
                : colors.lightGrey,
          },
          onChange: (e: any) => {
            let tempValues: stdObject = {};
            if (code === "FEC2") {
              tempValues[code] =
                e.target.value.length > 0
                  ? e.target.value.replace("T", " ")
                  : e.target.value;
            } else {
              tempValues[code] =
                e[`COD${searchType === "RES" ? "CLI" : searchType}`];
              tempValues[name] =
                e[`NOM${searchType === "RES" ? "CLI" : searchType}`];
              if (code === "CLI") {
                tempValues.customer = e;
                if (!emptys.includes(e.AGECLI) && e.AGECLI > 0) {
                  tempValues.AGE = e.AGECLI;
                  tempValues.ANO = usersList[e.AGECLI]?.NOMUSU;
                }
              }
            }
            setWindowValues({
              ...windowValues,
              service: { ...windowValues.service, ...tempValues },
            });
          },
        };
      }),
    buttons: [
      {
        label: t("p.open"),
        onClick: () => {
          if (validateData()) {
            directCreateService(false, packFuncs);
          }
        },
        color: colors.blue,
      },
      {
        label: t("p.saveAndClose"),
        onClick: () => {
          if (validateData()) {
            directCreateService(true, packFuncs);
            closeMsg();
          }
        },
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg();
          setWindowValues({});
        },
        color: colors.darkGrey,
      },
    ],
  };
};
